"use client";

import { c as _c } from "react/compiler-runtime";
import { Button, ButtonVariant, Input, Text, TextColor, TextSize, TextVariant, TextWeight } from "@workspace/ui/components";
// Form
import { Form, Formik } from "formik";
import Link from "next/link";
import { useRouter } from "next/navigation";
import React, { useState } from "react";
import styled from "styled-components";

// Context
import { useCustomer } from "@/context";
// DataLayer
import { loginEvent } from "@/dataLayer";
import validationSchema from "./validationSchema";
const SignInForm = t0 => {
  const $ = _c(14);
  const {
    noRedirect
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      unauthorized: false
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [status, setStatus] = useState(t1);
  const {
    state: t2,
    signIn
  } = useCustomer();
  const {
    isLoading
  } = t2;
  const router = useRouter();
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      email: "",
      password: ""
    };
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const initialValues = t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = validationSchema();
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const formSchema = t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      unauthorized: "Nieprawid\u0142owy adres email lub has\u0142o"
    };
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const statusContent = t5;
  let t6;
  if ($[4] !== noRedirect || $[5] !== router || $[6] !== signIn) {
    t6 = (values, t7) => {
      const {
        setSubmitting,
        resetForm
      } = t7;
      signIn({
        email: values.email,
        password: values.password
      }).then(resUser => {
        if (resUser.status === 200) {
          setTimeout(() => {
            resetForm();
            setSubmitting(false);
            setStatus({
              unauthorized: false
            });
            loginEvent();
            if (!noRedirect) {
              router.push("/moje-konto");
            }
          }, 1000);
        }
        if (resUser.status === 306) {
          setSubmitting(false);
          setStatus({
            unauthorized: true
          });
        } else {
          setSubmitting(false);
        }
      });
    };
    $[4] = noRedirect;
    $[5] = router;
    $[6] = signIn;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== isLoading || $[9] !== status) {
    t7 = t8 => {
      const {
        values: values_0,
        touched,
        errors,
        setFieldValue
      } = t8;
      return <SignInFormWrapper><HeaderWrapper><Text variant={TextVariant.H5} text={"Zaloguj si\u0119"} color={TextColor.BLACK} /><Text text={"Zaloguj si\u0119 do swojego konta"} color={TextColor.GRAYSCALE_600} /></HeaderWrapper>{Object.values(status).indexOf(true) > -1 && <InfoBar $error={status.unauthorized} $success={false}><Text variant={TextVariant.P} text={Object.values(statusContent)[Object.values(status).indexOf(true)]} color={TextColor.WHITE} /></InfoBar>}<FormWrapper><Input autoFocus={true} id="email" value={values_0.email} name="email" label="Adres email" placeholder={"Wprowad\u017A adres email"} focused={touched.email} validated={typeof errors.email === "undefined" && touched.email} error={typeof errors.email !== "undefined" && touched.email} errorHelper={errors.email} onChange={e => setFieldValue("email", e.target.value)} icon={false} /><Input id="password" value={values_0.password} name="password" label={"Has\u0142o"} placeholder={"Wprowad\u017A has\u0142o"} focused={touched.password} validated={typeof errors.password === "undefined" && touched.password} error={typeof errors.password !== "undefined" && touched.password} errorHelper={errors.password} onChange={e_0 => setFieldValue("password", e_0.target.value)} icon={true} iconPosition="right" type="password" /><ButtonsWrapper><Button type="submit" variant={ButtonVariant.PRIMARY} text={"Zaloguj si\u0119"} disabled={isLoading} loading={isLoading} /></ButtonsWrapper><ExtraLink><Text text={"Nie pami\u0119tasz has\u0142a?"} fontSize={TextSize.S} /><Link href="/odzyskiwanie-hasla"><Text text={"Przywr\xF3\u0107 has\u0142o"} color={TextColor.PRIMARY_500} weight={TextWeight.SEMIBOLD} fontSize={TextSize.S} /></Link></ExtraLink></FormWrapper></SignInFormWrapper>;
    };
    $[8] = isLoading;
    $[9] = status;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t6 || $[12] !== t7) {
    t8 = <Formik initialValues={initialValues} validationSchema={formSchema} onSubmit={t6}>{t7}</Formik>;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
};
const InfoBar = styled.div`
  width: 100%;
  margin-bottom: 20px;
  text-align: center;
  padding: 2px 10px;

  ${({
  theme,
  $error
}) => $error && `
    background-color: ${theme.colors.ERROR_400};
  `}
  ${({
  theme,
  $success
}) => $success && `
    background-color: ${theme.colors.GRAYSCALE_500};
  `}
`;
const ExtraLink = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  text-align: center;

  > div:first-child {
    margin-right: 4px;
  }
`;
const FormWrapper = styled(Form)`
  display: flex;
  flex-direction: column;

  .MuiFormGroup-root {
    margin-bottom: 0;
    margin-right: 16px;
    width: 100%;
  }

  button {
    width: 100%;
  }

  .MuiFormGroup-root {
    margin-bottom: 16px;
  }
`;
const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;

  img {
    margin-bottom: 16px;
  }

  h5 {
    margin-bottom: 16px;
  }

  p {
    letter-spacing: 0.16px;
    margin-bottom: 24px;
  }
`;
const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;

  ${({
  theme
}) => theme.mediaQueries.sm} {
    flex-direction: column-reverse;
    justify-content: center;
  }
`;
const SignInFormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100% !important;
  max-width: 335px;

  ${({
  theme
}) => theme.mediaQueries.sm} {
    max-width: 100%;
  }
`;
export default SignInForm;